import { FC, useEffect, useState, useMemo } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { Subject, interval } from 'rxjs'
import { takeUntil, tap } from 'rxjs/operators'
import moment from 'moment'
import styles from 'components/features/coaching/advisorVideoCall/NotStartedYet/NotStartedYet.styl'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { useNativeHistory } from 'helpers/hookHelpers'


type NotStartedYetProps = {
}
export const NotStartedYet: FC<NotStartedYetProps> = () => {
  const [cache, render] = useState({})
  const { hasHistory } = useNativeHistory()
  const start_time = useStoreSelector((state) => state.data.advisors.videoCallDetails.details?.start_time)
  const finish_time = useStoreSelector((state) => state.data.advisors.videoCallDetails.details?.finish_time)

  useEffect(() => {
    const destroy$: Subject<void> = new Subject()

    interval(1000).pipe(
      takeUntil(destroy$),
      tap(() => render({})),
    ).subscribe()

    return () => {
      destroy$.next()
    }
  }, [])

  const remainChild = useMemo(() => {
    if (moment().isAfter(start_time)) {
      return (
        <>
          <div className={ styles.remain }>
            Session Completed
          </div>
          <div className={ styles.scheduled }>
            It took place on { moment(start_time).format('MMMM Do, h:mm A.') }
          </div>
          <br /><br />
          <NavigationLink to='coaching'>
            <Button>GO TO STATUS</Button>
          </NavigationLink>
        </>
      )
    }

    return (
      <>
        <div className={ styles.remainHeader }>
          The session has not yet started
        </div>
        <div className={ styles.remain }>
          Beginning { moment(start_time).fromNow() }
        </div>
        <div className={ styles.scheduled }>
          It is scheduled for { moment(start_time).format('MMMM Do, h:mm A.') }
        </div>
        <br /><br />
        <NavigationLink to='coaching'>
          <Button>{ hasHistory ? 'GO BACK' : 'GO TO STATUS' }</Button>
        </NavigationLink>
      </>
    )
  }, [finish_time, start_time, cache, hasHistory])

  if (!start_time) {
    return null
  }

  return (
    <div className={ styles.notStartedYet }>
      { remainChild }
    </div>
  )
}


